import auth0 from 'auth0-js';
import Vue from 'vue';
import axios from 'axios';
import { EventBus } from '@/event-bus.js';
import { store } from './store';

const API_URL = process.env.VUE_APP_LAYER_URL;

let URL;
if (location.href.indexOf('localhost:3000') > -1) {
  URL = 'http://localhost:3000';
} else if (location.href.indexOf('stage') > -1) {
  URL = 'https://kontalk-stage.surge.sh';
} else if (location.href.indexOf('kontalk.com.br') > -1) {
  URL = 'https://kontalk.com.br';
} else {
  URL = 'https://vendas.sejazipper.com';
}

// exchange the object with your own from the setup step above.
const webAuth = new auth0.WebAuth({
  domain: 'kontalk.auth0.com',
  clientID: 'ws2kTUpfK5BVLw39uMIeDLBBv4ywrG7v',
  // make sure this line is contains the port: 8080
  redirectUri: `${URL}/callback`,
  // we will use the api/v2/ to access the user information as payload
  audience: 'https://kontalk.auth0.com/api/v2/',
  responseType: 'token id_token',
  scope: 'openid profile', // define the scopes you want to use
});

const auth = new Vue({
  computed: {
    token: {
      get() {
        return localStorage.getItem('id_token');
      },
      set(id_token) {
        localStorage.setItem('id_token', id_token);
      },
    },
    accessToken: {
      get() {
        return localStorage.getItem('access_token');
      },
      set(accessToken) {
        localStorage.setItem('access_token', accessToken);
      },
    },
    expiresAt: {
      get() {
        return localStorage.getItem('expires_at');
      },
      set(expiresIn) {
        const expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime());
        localStorage.setItem('expires_at', expiresAt);
      },
    },
    vuexExpiresAt: {
      get() {
        return sessionStorage.getItem('vuex_expires_at');
      },
      set(expiresIn) {
        const expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime());
        sessionStorage.setItem('vuex_expires_at', expiresAt);
      },
    },
    user: {
      get() {
        return JSON.parse(localStorage.getItem('user'));
      },
      set(user) {
        localStorage.setItem('user', JSON.stringify(user));
      },
    },
  },
  methods: {
    newLogin(user, password, cb) {
      webAuth.client.login(
        {
          realm: 'Username-Password-Authentication', // connection name or HRD domain
          username: user,
          password,
          audience: 'https://kontalk.auth0.com/api/v2/',
          scope: 'openid profile',
        }, (err, result) => {
          cb(err, result);
          if (err) return;
          this.handleAuthentication(err, result);
        },
      );
    },

    forgotPassword(user, cb) {
      return webAuth.changePassword({
        connection: 'Username-Password-Authentication',
        email: user,
      }, cb);
    },

    signUp(user, password, cb) {
      webAuth.signup({
        connection: 'Username-Password-Authentication',
        email: user,
        password,
      }, cb);
    },

    async checkVuex() {
      if (this.vuexExpiresAt <= new Date().getTime()) {
        this.vuexExpiresAt = 24 * 60;
      }
    },

    async login() {
      webAuth.popup.authorize({
        redirectUri: `${URL}/callback`,
      }, (err, authResult) => {
        this.handleAuthentication(err, authResult);
      });
    },
    callback() {
      webAuth.popup.callback();
    },
    logout() {
      return new Promise(async (resolve, reject) => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('user');
        sessionStorage.removeItem('vuex_expires_at');

        webAuth.logout({
          returnTo: URL,
          client_id: 'ws2kTUpfK5BVLw39uMIeDLBBv4ywrG7v',
        });
      });
    },
    isAuthenticated() {
      return new Date().getTime() < this.expiresAt;
    },
    handleAuthentication(err, authResult) {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.expiresAt = authResult.expiresIn;
        this.vuexExpiresAt = 24 * 60;
        this.accessToken = authResult.accessToken;
        this.token = authResult.idToken;
        webAuth.client.userInfo(
          authResult.accessToken,
          (err, user) => {
            this.user = user;
            this.validateUser(user);
          },
        );
      } else if (err) {
        this.logout();
      }
    },
    async validateUser(user) {
      const { sub: id } = user;
      axios.post(API_URL, {
        query: `query findSellerById($id: String) {
          findSellerById(id: $id){
            _id
          }
        }`,
        variables: {
          id,
        },
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
        crossDomain: true,
      }).then((response) => {
        if (response.data.data.findSellerById) {
          location.href = location.href.replace(/callback.*/, '');
          return;
        }
        const snackBar = {};
        snackBar.text = 'Usuário ou senha incorreta';
        snackBar.value = true;
        snackBar.color = 'red';
        EventBus.$emit('activeSnackBar', snackBar);
        setTimeout(this.logout, 3000);
      });
    },
  },
});

export default {
  install(Vue) {
    Vue.prototype.$auth = auth;
  },
};
